import React from 'react';
export function EmotionalTransition() {
  return <section className="py-16 px-4 bg-blue-900 text-white text-center" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        <p className="text-xl md:text-2xl leading-relaxed font-medium mb-6 text-blue-100" data-id="element-57">
          E anche quando ami il tuo lavoro, alla fine della giornata ti senti
          stanco e con la sensazione di non riuscire mai a stare al passo con
          tutto.
        </p>
        <p className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-58">
          Molti insegnanti vivono esattamente questa situazione.
        </p>
        <p className="text-xl text-blue-200" data-id="element-59">
          Non perché manchi la passione o la voglia di insegnare. Il vero
          problema è che non esiste un sistema semplice che raccolga tutte le
          attività in modo chiaro e pronto all’uso.
        </p>
      </div>
    </section>;
}